module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/ring.e677bd0e.mp4";